import React from 'react'

const fullServiceC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2 7C2 5.34315 3.34315 4 5 4H27C28.6569 4 30 5.34315 30 7V20C30 21.6569 28.6569 23 27 23H17V28H22C22.5523 28 23 28.4477 23 29C23 29.5523 22.5523 30 22 30H10C9.44772 30 9 29.5523 9 29C9 28.4477 9.44772 28 10 28H15V23H5C3.34315 23 2 21.6569 2 20V7ZM27 21C27.5523 21 28 20.5523 28 20V7C28 6.44772 27.5523 6 27 6H5C4.44772 6 4 6.44772 4 7V20C4 20.5523 4.44772 21 5 21H27Z" />
  </svg>
)

export default fullServiceC
